import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-foreground-950/10"
          : "bg-background-50/60 backdrop-blur-sm border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-10">
        <div className="flex h-16 md:h-20 items-center justify-between gap-6">
          <a href="#top" className="flex items-center gap-3 shrink-0 cursor-pointer">
            <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-newspaper-line text-xl"></i>
            </span>
            <span className="leading-none">
              <span className="block font-heading text-lg md:text-xl font-bold tracking-tight text-foreground-950">
                黑料免费
              </span>
              <span className="hidden sm:block mt-1 text-[11px] tracking-[0.25em] text-foreground-500">
                ACCESS &amp; GUIDE
              </span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="px-3 py-2 rounded-md text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#subscribe"
              className="hidden sm:inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-notification-3-line"></i>
              订阅更新
            </a>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setOpen((v) => !v)}
              className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-foreground-950/15 text-foreground-800 cursor-pointer"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
            </button>
          </div>
        </div>

        {open && (
          <nav className="lg:hidden pb-4 grid grid-cols-2 gap-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="px-3 py-3 rounded-md bg-background-100 text-sm text-foreground-800 hover:text-primary-600 transition-colors cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
}